import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { ChooseNewNumberPage } from "@nju/feature-portal-msisdn";
import { RespectOrchestratorState } from "@nju/feature-portal-orchestrator";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function ChooseNumber() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent>
        <ClientSideOnly>
          <RespectOrchestratorState
            mode={["mobile", "postpaid"]}
            state="ITEM_SELECTION"
          >
            <ChooseNewNumberPage />
          </RespectOrchestratorState>
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
